(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.__wmNYInit) return;
  window.__wmNYInit = true;

  // Canvas overlay (transparent)
  var c = document.createElement('canvas');
  var ctx = c.getContext('2d');
  c.id = 'wm-fireworks-canvas';
  Object.assign(c.style, {
    position: 'fixed',
    left: '0', top: '0',
    width: '100vw', height: '100vh',
    pointerEvents: 'none',
    zIndex: '2147483647'
  });
  document.body.appendChild(c);

  function resize() {
    var dpr = window.devicePixelRatio || 1;
    c.width = Math.floor(window.innerWidth * dpr);
    c.height = Math.floor(window.innerHeight * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  window.addEventListener('resize', resize);
  resize();

  // ===== Tuning =====
  var LAUNCH_RATE = 0.8;        // launches per second
  var ROCKET_SPEED_MIN = 520;   // px/sec
  var ROCKET_SPEED_MAX = 720;
  var GRAVITY = 520;            // px/sec^2
  var DRAG = 0.015;

  var SPARKS_MIN = 45;
  var SPARKS_MAX = 90;
  var BURST_SPEED_MIN = 160;
  var BURST_SPEED_MAX = 380;
  var SPARK_LIFE_MIN = 0.9;     // seconds
  var SPARK_LIFE_MAX = 1.6;

  // Trails: instead of black fade, we "fade to transparent"
  // Smaller number = longer trails. Try 0.08–0.18.
  var CLEAR_ALPHA = 0.12;

  var COLORS = [
    '#ffffff', '#ffd166', '#ff6b6b', '#f72585', '#b5179e',
    '#7209b7', '#4361ee', '#4cc9f0', '#80ed99', '#ffd60a'
  ];

  function rand(a, b) { return a + Math.random() * (b - a); }
  function pick(arr) { return arr[(Math.random() * arr.length) | 0]; }

  var rockets = [];
  var sparks = [];

  function launch() {
    var x = rand(window.innerWidth * 0.15, window.innerWidth * 0.85);
    var y = window.innerHeight + rand(10, 40);
    var targetY = rand(window.innerHeight * 0.18, window.innerHeight * 0.45);

    rockets.push({
      x: x, y: y,
      vx: rand(-50, 50),
      vy: -rand(ROCKET_SPEED_MIN, ROCKET_SPEED_MAX),
      targetY: targetY,
      color: pick(COLORS),
      trail: []
    });
  }

  function explode(r) {
    var count = (rand(SPARKS_MIN, SPARKS_MAX) | 0);
    var baseColor = r.color;

    for (var i = 0; i < count; i++) {
      var ang = Math.random() * Math.PI * 2;
      var spd = rand(BURST_SPEED_MIN, BURST_SPEED_MAX);
      var life = rand(SPARK_LIFE_MIN, SPARK_LIFE_MAX);

      sparks.push({
        x: r.x, y: r.y,
        vx: Math.cos(ang) * spd,
        vy: Math.sin(ang) * spd,
        life: life,
        age: 0,
        color: baseColor,
        size: rand(1.2, 2.4)
      });
    }
  }

  var last = performance.now();
  var acc = 0;

  function step(now) {
    var dt = Math.min(0.033, (now - last) / 1000);
    last = now;

    // Fade previous frame WITHOUT darkening the page:
    // Use destination-out to reduce alpha of existing pixels.
    ctx.save();
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(0,0,0,' + CLEAR_ALPHA + ')';
    ctx.fillRect(0, 0, window.innerWidth, window.innerHeight);
    ctx.restore();

    // Launch timing
    acc += dt * LAUNCH_RATE;
    while (acc >= 1) { launch(); acc -= 1; }

    // Rockets
    for (var i = rockets.length - 1; i >= 0; i--) {
      var r = rockets[i];

      r.vy += GRAVITY * 0.22 * dt;
      r.x += r.vx * dt;
      r.y += r.vy * dt;

      r.trail.push({ x: r.x, y: r.y });
      if (r.trail.length > 14) r.trail.shift();

      // Trail line
      ctx.beginPath();
      for (var t = 0; t < r.trail.length; t++) {
        var p = r.trail[t];
        if (t === 0) ctx.moveTo(p.x, p.y);
        else ctx.lineTo(p.x, p.y);
      }
      ctx.strokeStyle = r.color;
      ctx.globalAlpha = 0.55;
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.globalAlpha = 1;

      // Rocket head
      ctx.beginPath();
      ctx.fillStyle = r.color;
      ctx.arc(r.x, r.y, 2.2, 0, Math.PI * 2);
      ctx.fill();

      if (r.y <= r.targetY || r.vy > -120) {
        explode(r);
        rockets.splice(i, 1);
      }
    }

    // Sparks
    for (var j = sparks.length - 1; j >= 0; j--) {
      var s = sparks[j];
      s.age += dt;

      s.vx *= (1 - DRAG);
      s.vy *= (1 - DRAG);
      s.vy += GRAVITY * dt;

      s.x += s.vx * dt;
      s.y += s.vy * dt;

      var k = 1 - (s.age / s.life);
      if (k <= 0) { sparks.splice(j, 1); continue; }

      ctx.globalAlpha = Math.max(0, k);
      ctx.fillStyle = s.color;
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.size, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;
    }

    requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
  console.log('[fireworks] running (transparent)');
})();
